import { BuyerProjectDeadline } from '@/types';
import { Trans } from '@lingui/react/macro';
import { AwaitingSignaturesPill } from './AwaitingSignaturesPill';
import { DeadlinePill } from './DeadlinePill';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import theme from './HomePage.module.scss';
import { DateDisplay } from '@ygtechnologies/bygr-frontend-component-library';
import { BuyerCurrencyDisplay } from '@/buyer/components/BuyerCurrencyDisplay';
import { Button, Card, Dot } from '@ygtechnologies/rubus-ui';

export interface DeadlineItemProps {
    deadline: BuyerProjectDeadline;
    selectedDeadlineId: number | null;
    handleSelectDeadline: (deadlineId: number) => void;
    isSelected: boolean;
    color: 'success' | 'warning' | 'info' | 'danger';
    daysLeft: number;
}

export const DeadlineRow: React.FC<DeadlineItemProps> = ({
    deadline,
    handleSelectDeadline,
    isSelected,
    color,
    daysLeft,
}) => {
    return (
        <Card className={theme.deadlineRow}>
            <h4 className={theme.deadlineName}>
                <span className={theme.deadlineNameWithDot}>
                    {deadline.name}
                    {deadline.awaitingSignatures > 0 && <Dot variant="warning" />}
                </span>
            </h4>
            <div className={theme.deadlineSignaturesRow}>
                <Trans>Awaiting signatures:</Trans>
                <AwaitingSignaturesPill awaitingSignatures={deadline.awaitingSignatures} color={color} />
            </div>
            <div className={theme.deadlineDate}>
                <DateDisplay value={deadline.deadline} />
                <DeadlinePill daysLeft={daysLeft} color={color} />
            </div>
            <div className={theme.deadlinePrice}>
                {deadline.totalPrice !== undefined && <BuyerCurrencyDisplay value={deadline.totalPrice} alwaysShowSign />}
            </div>
            {isSelected ? (
                <Button variant="primary" size="sm" icon={faCheck} iconPosition="left">
                    <Trans>Deadline selected</Trans>
                </Button>
            ) : (
                <Button variant="tertiary" size="sm" onClick={() => handleSelectDeadline(deadline.id)}>
                    <Trans>Select deadline</Trans>
                </Button>
            )}
        </Card>
    );
};

export const DeadlineCard: React.FC<DeadlineItemProps> = ({
    deadline,
    handleSelectDeadline,
    isSelected,
    color,
    daysLeft,
}) => {
    return (
        <Card className={theme.deadlineCard}>
            <div className={theme.deadlineCardHeader}>
                <div className={theme.deadlineCardDate}>
                    <DateDisplay value={deadline.deadline} />
                </div>
                <DeadlinePill daysLeft={daysLeft} color={color} />
            </div>

            <h4>{deadline.name}</h4>
            {deadline.awaitingSignatures > 0 && (
                <div className={theme.deadlineCardDotRow}>
                    <Dot variant="warning" />
                </div>
            )}

            <div className={theme.deadlineCardSignaturesRow}>
                <Trans>Awaiting signatures:</Trans>
                <AwaitingSignaturesPill awaitingSignatures={deadline.awaitingSignatures} color={color} />
            </div>

            <div className={theme.deadlineCardSumRow}>
                <span className={theme.deadlineCardSumLabel}>
                    <Trans>Sum:</Trans>
                </span>
                <span className={theme.deadlineCardSumPrice}>
                    <BuyerCurrencyDisplay value={deadline.totalPrice} alwaysShowSign />
                </span>
            </div>

            {isSelected ? (
                <Button variant="primary" size="sm" icon={faCheck} iconPosition="left">
                    <Trans>Deadline selected</Trans>
                </Button>
            ) : (
                <Button variant="tertiary" size="sm" onClick={() => handleSelectDeadline(deadline.id)}>
                    <Trans>Select deadline</Trans>
                </Button>
            )}
        </Card>
    );
};
